import Card from "@/components/primitives/card";
import React from "react";

export default function LeaderboardGuide() {
  return (
    <Card header={{ title: "Leaderboard Guide" }}>
      <p>
        <strong>Overview</strong>
      </p>
      <p>
        Welcome to our Showcase page, where we highlight the top-performing
        users in our sports picks community! Our dynamic leaderboard features
        the "hottest" users with the highest positive total units, exceptional
        win/loss records, and remarkable winning streaks. These skilled
        individuals have consistently demonstrated their sports predicting
        prowess and serve as inspirations for the community. On the other hand,
        we also feature the "coldest" users, recognizing that everyone faces ups
        and downs in sports predictions.
      </p>
      <p className="mt-4">
        <strong>Leaderboard Prizes</strong>
      </p>
      <p>
        We are committed to rewarding and recognizing the top performers in our
        community. As users engage in making accurate picks, accumulating
        positive total units, maintaining impressive win/loss records, and
        achieving remarkable winning streaks, they will be in contention for our
        coveted top performer prizes. These rewards serve as tokens of
        appreciation for their dedication, expertise, and contributions to our
        thriving community. We believe that by offering these incentives, we can
        further motivate and inspire our users to aim for excellence in their
        sports picks journey while fostering healthy competition and camaraderie
        among sports enthusiasts. Get ready to compete, excel, and claim your
        spot among the top performers to seize exciting rewards at our sports
        picks Showcase!
      </p>
    </Card>
  );
}
